import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { LoaderContainer } from '../components/Layout/Style/Layout.style';
import { Loader } from '../components';
import { useAuth0 } from '../__mocks__/@auth0/auth0-react';

const PrivateRoute = ({ element }: any) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  if (isLoading) {
    return (
      <LoaderContainer>
        <Loader size={30} />
      </LoaderContainer>
    );
  }

  return isAuthenticated ? (
    element
  ) : (
    <Navigate
      to="/"
      replace
      state={{ returnTo: location.pathname + location.search }}
    />
  );
};

export default PrivateRoute;
